export const removeSearchParam = ({ path, param }: { path?: string; param: string }): string | undefined => {
  if (!path) {
    return path;
  }
  const base = 'https://www.cian.ru/';

  const urlObj = new URL(path, base);
  urlObj.searchParams.delete(param);

  return urlObj.pathname + urlObj.search;
};
